// ConfirmModal.jsx
import React from "react";
import "./confirmmodal.css"; // We'll style it

const ConfirmModal = ({ show, onClose, onConfirm, message }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message || "Are you sure?"}</p>
        <div className="modal-buttons">
          <button className="btn btn-primary" onClick={onConfirm}>
            Yes
          </button>
          <button className="btn white" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
